import { createSelector } from 'reselect'
import { getShared } from './helpers'

export const getServerTimestampInMilliseconds = createSelector(
  [getShared],
  (shared): number => shared.serverTimestampInMilliseconds || Date.now()
)
